<template>
  <div class="con" :class="{'dark':active2}">
    <div class="mm">
      <div class="main">
        <a class="left" href="/index.html">
          <img class="a" src="../assets/rj/topLogo.png" alt />
        </a>
        <div class="right">
          <ul>
            <li
              class="animated fadeIn"
              :class="page === 'home' ? 'showLine' : ''"
              @click="goto('home')"
              style="animation-delay: 0.2s"
            >
              <a>{{$t('head').index}}</a>
            </li>
            <li
              class="animated fadeInDown"
              :class="page === 'about' ? 'showLine' : ''"
              @click="goto('about')"
              style="animation-delay: 0.3s"
            >
              <a>{{$t('head').about[0]}}</a>
              <div>
                <p
                  v-for="(item,index) in aList"
                  :key="index"
                  class="animated fadeInUp"
                  :class="{subtitle:$i18n.locale=='en'}"
                  :style="{animationDelay:`${index*0.1+'s'}`}"
                  @click.stop="gotoWhich('about',index)"
                >{{item}}</p>
              </div>
            </li>
            <li
              class="animated fadeInDown"
              :class="page === 'pro' ? 'showLine' : ''"
              @click="goto('pro')"
              style="animation-delay: 0.4s"
            >
              <a>{{$t('head').produce[0]}}</a>
              <div>
                <p
                  v-for="(item,index) in pList"
                  :key="index"
                  class="animated fadeInUp"
                  :class="{subtitle:$i18n.locale=='en'}"
                  :style="{animationDelay:`${index*0.1+'s'}`}"
                  @click.stop="gotoWhich('pro',index)"
                >{{item}}</p>
              </div>
            </li>
            <li
              class="animated fadeInDown"
              :class="page === 'job' ? 'showLine' : ''"
              @click="goto('job')"
              style="animation-delay: 0.5s"
            >
              <a>{{$t('head').service[0]}}</a>
              <div>
                <p
                  v-for="(item,index) in jList"
                  :key="index"
                  class="animated fadeInUp"
                  :class="{subtitle:$i18n.locale=='en'}"
                  :style="{animationDelay:`${index*0.1+'s'}`}"
                  @click.stop="gotoWhich2(index)"
                >{{item}}</p>
              </div>
            </li>
            <li
              class="animated fadeInDown"
              :class="page === 'news' ? 'showLine' : ''"
              @click="goto('news')"
              style="animation-delay: 0.6s"
            >
              <a>{{$t('head').news[0]}}</a>
              <div>
                <p
                  v-for="(item,index) in nList"
                  :key="index"
                  class="animated fadeInUp"
                  :class="{subtitle:$i18n.locale=='en'}"
                  :style="{animationDelay:`${index*0.1+'s'}`}"
                  @click.stop="gotoWhich('news',index)"
                >{{item}}</p>
              </div>
            </li>
            <li
              class="animated fadeInDown"
              :class="page === 'contact' ? 'showLine' : ''"
              @click="goto('contact')"
              style="animation-delay: 0.8s"
            >
              <a>{{$t('head').contact}}</a>
            </li>
          </ul>
        </div>
        <div class="phone">
          <div>
            <span>
              <i class="iconfont icon-shangcheng"></i>
            </span>
<!--            <a href>-->
<!--              <img src="../assets/rj/shop.jpg" alt />-->
<!--            </a>-->
          </div>
          <div>
            <span>
              <i class="iconfont icon-diqiu"></i>
            </span>
            <div class="chose">
              <p @click="changeLan('zh-CN')">中文版</p>
              <p @click="changeLan('en')">EN</p>
            </div>
          </div>
          <div>
            <span>
              <i class="iconfont icon-sousuo" @click="showS"></i>
            </span>
          </div>
          <a class="dh" href="tel:0574-28820588">+0574-28820588</a>
        </div>
      </div>
    </div>
    <div class="search" :class="{'showSearch':isShowSearch}">
      <div class="form">
        <input type="text" placeholder="Search..." v-model="keywords" />
        <span class="goto" @click="gotoPros">
          <i class="iconfont icon-sousuo"></i>
        </span>
        <span class="close" @click="his">
          <i class="el-icon-close"></i>
        </span>
      </div>
    </div>

    <div class="top animated fadeInDown">
      <a href="/index.html" class="l1">
        <img class="a" src="../assets/rj/topLogo.png" alt />
      </a>
      <div class="mNav" @click="menuSwitch" :class="{active:menuShow}">
        <span class="burger"></span>
        <span class="burger"></span>
        <span class="burger"></span>
      </div>
    </div>
    <!--        <div class="menuBox" :class="{open: menuShow}">-->
    <!--            <ul>-->
    <!--                <li ><a href="/index.html">首页</a></li>-->
    <!--                <li style="transition-delay: 0.2s"><a href="/about.html">关于汇燊</a></li>-->
    <!--                <li style="transition-delay: 0.3s"><a href="/pro.html">产品中心</a></li>-->
    <!--                <li style="transition-delay: 0.4s"><a href="/news.html">汇燊动态</a></li>-->
    <!--                <li style="transition-delay: 0.5s"><a href="/sale.html">技术支持</a></li>-->
    <!--                <li style="transition-delay: 0.6s"><a href="/contact.html">联系汇燊</a></li>-->
    <!--            </ul>-->
    <!--        </div>-->
  </div>
</template>

<script>
import Scrollbar from "smooth-scrollbar";
import { setup } from "../local/index";
export default {
  name: "first",
  data() {
    return {
      isShowSearch: false,
      menuShow: false,
      keywords: "",
      select: 0,
      menuOpen: false,
      active2: false,
      scrollbar: "",
      top: "",
      aList: [
        this.$t("head").about[1],
        this.$t("head").about[2],
        this.$t("head").about[3],
        this.$t("head").about[4],
        this.$t("head").about[5],
        this.$t("head").about[6],
      ],
      pList: [this.$t("head").produce[1], this.$t("head").produce[2]],
      jList: [
        this.$t("head").service[1],
        this.$t("head").service[2],
        this.$t("head").service[3],
      ],
      nList: [this.$t("head").news[1], this.$t("head").news[2]],
    };
  },
  props: ["page"],
  // watch: {
  //     $route: 'getScrollbar'
  // },
  mounted() {
    this.$nextTick(() => {
      this.getScrollbar();
    });
  },
  methods: {
    changeLan(n) {
      this.$i18n.locale = n;
      window.localStorage.setItem("language", n);
      setup(n);
      window.location.reload();
    },
    gotoWhich(page, num) {
      const link = `./${page}.html?index=${num}`;
      window.open(link, "_self");
    },
    gotoWhich2(n) {
      const link = "./download.html?index=0";
      const link2 = "./service.html";
      const link3 = "./help.html";
      if (n === 0) {
        window.open(link, "_self");
      } else if (n === 1) {
        window.open(link2, "_self");
      } else {
        window.open(link3, "_self");
      }
    },
    his() {
      this.isShowSearch = false;
    },
    showS() {
      this.isShowSearch = true;
    },
    menuSwitch() {
      this.menuShow = !this.menuShow;
      this.$emit("menushow", this.menuShow);
    },
    change(n) {
      const link = `/about.html?index=${n}`;
      window.open(link, "_self");
    },
    gotoPros() {
      const link = `/proSearch.html?name=${this.keywords}`;
      window.open(link, "_self"); // this.project.link
    },
    aStyle(n) {
      return { transitionDelay: n * 0.1 + "s" };
    },
    goto(n) {
      const link = `/${n}.html`;
      window.open(link, "_self");
    },
    scrollHeader(scrollTop) {
      this.active2 = scrollTop > 200 ? true : false;
    },
    getScrollbar() {
      this.$nextTick(() => {
        this.scrollbar = Scrollbar.get(
          document.getElementById("scroller-wrapper")
        );
        this.active2 = false;
        this.select = parseInt(localStorage.getItem("home.html"));
        let scrollHeader = this.scrollHeader;
        if (this.scrollbar) {
          this.scrollbar.addListener((status) => {
            scrollHeader(status.offset.y);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: all 1s;
  .mm {
    width: 100%;
    padding-top: 10px;
    .main {
      width: 90%;
      display: flex;
      flex-direction: row;
      transition: all 600ms;
      margin: 0 auto;
      align-items: center;
      .left {
        display: inline-block;
        width: 136px;
        height: 33px;
        position: relative;
        overflow: hidden;
        img {
          position: absolute;
          left: -100%;
          top: 0;
          height: 100%;
          width: 100%;
          animation: show 1s linear forwards;
          opacity: 0;
        }
        @keyframes show {
          from {
            left: -100%;
            opacity: 0;
          }
          to {
            left: 0;
            opacity: 1;
          }
        }
      }
      .right {
        display: flex;
        flex-direction: row;
        width: 60%;
        justify-content: space-between;
        margin-left: 10%;
        ul {
          list-style: none;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          li {
            position: relative;
            margin-left: 6%;
            cursor: pointer;
            a {
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
              font-family: "itbook";
              list-style: none;
              margin: 0;
              border: 0;
              outline: none;
              cursor: pointer;
              transition: 0.3s;
              text-decoration: none;
              position: relative;
              display: block;
              padding: 0 20px;
              height: 80px;
              line-height: 80px;
              font-size: 16px;
              color: white;
              &:hover {
                color: #ea5404;
              }
            }
            div {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: 100%;
              width: 160px;
              z-index: 100;
              transition: all 2s;
              display: none;
              p {
                padding: 12px 0;
                background-color: #ea5404;
                color: white;
                text-align: center;
                font-size: 14px;
                animation-duration: 1s;
                transition: all 1s;
                text-transform: capitalize;
              }
              .subtitle{
                font-size: 12px;
                // text-transform: none;
              }
            }
            &:hover {
              div {
                display: block;
              }
            }
          }
          // li:nth-child(3) {
          //   div {
          //     left: -20px;
          //   }
          // }
          .showLine {
            a {
              color: #ea5404;
            }
          }
        }
      }
      .phone {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 5%;
        div {
          margin-right: 30px;
          position: relative;
          span {
            color: #cccccc;
            cursor: pointer;
            transition: all 600ms;
            i {
              font-size: 20px;
            }
            &:hover {
              color: white;
            }
          }
          a {
            position: absolute;
            left: -30px;
            top: 100%;
            transition: all 600ms;
            opacity: 0;
            transform: translateY(20px);
            img {
              height: 80px;
              width: 80px;
              object-fit: contain;
            }
          }
          &:hover {
            a {
              opacity: 1;
              transform: translateY(0);
            }
          }
        }
        div:nth-child(2) {
          position: relative;
          .chose {
            position: absolute;
            left: -30px;
            top: 100%;
            transform: scale(0);
            width: 90px;
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 5px;
            transition: all 600ms;
            p {
              color: white;
              text-align: center;
              font-size: 14px;
              transition: all 600ms;
              cursor: pointer;
              &:hover {
                color: #ea5404;
              }
            }
            p:nth-child(1) {
              padding: 10px 0;
            }
            p:nth-child(2) {
              padding-bottom: 10px;
            }
          }
          &:hover {
            .chose {
              transform: scale(1);
            }
          }
        }
        .dh {
          display: inline-block;
          width: 167px;
          height: 26px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 5px;
          text-align: center;
          line-height: 26px;
          font-size: 16px;
          color: white;
          margin-left: 30px;
        }
      }
    }
  }
  .search {
    position: absolute;
    z-index: 2;
    top: 200px;
    transform: translateY(-800px);
    left: 0;
    transition: all 1s;
    height: 100%;
    width: 100%;
    background: #14151c;
    .form {
      position: relative;
      height: 100%;
      margin: 0 calc(5% + 116px) 0 calc(5% + 170px);
      input {
        -webkit-font-smoothing: antialiased;
        visibility: visible;
        box-sizing: border-box;
        font-family: "Open Sans", sans-serif;
        -webkit-appearance: none;
        border: none;
        border-radius: 0;
        width: 100%;
        color: #ffffff;
        font-size: 2.4rem;
        height: 100%;
        background-color: transparent;
        padding-right: 170px;
      }
      input:focus {
        outline: none;
      }
      .goto {
        position: absolute;
        right: 50px;
        top: 25px;
        height: 40px;
        width: 40px;
        background-color: #dd85ac;
        border-radius: 50%;
        color: white;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        transform: scale(0);
        transition: all 1s;
        transition-delay: 1s;
        i {
          font-size: 25px;
        }
      }
      .close {
        position: absolute;
        right: 0;
        top: 25px;
        height: 40px;
        width: 40px;
        border-radius: 50%;
        color: white;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        transform: scale(0);
        transition: all 1s;
        transition-delay: 1.5s;
        i {
          font-size: 25px;
        }
      }
    }
    &::before {
      content: "";
      display: inline-block;
      height: 190px;
      width: 1px;
      background-color: white;
      left: 50%;
      top: -200px;
      position: absolute;
    }
    &::after {
      content: "";
      display: inline-block;
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background-color: white;
      left: 49.8%;
      top: -10px;
      position: absolute;
    }
  }
  .showSearch {
    transform: translateY(0);
    .form {
      .goto,
      .close {
        transform: scale(1);
      }
    }
  }
  .top {
    display: none;
  }
  .menuBox {
    position: fixed;
    top: -100vh;
    left: 0;
    height: 100vh;
    width: 80%;
    background: #2bad38;
    z-index: 1010;
    transition: 0.8s;
    display: block;
  }
  .menuBox.open {
    left: 0;
    top: 69px;
    padding-top: 20px;
    ul {
      li {
        transform: matrix(1, 0, 0, 1, 0, 0);
      }
    }
  }
  .menuBox ul {
    display: block;
    font-size: 18px;
    width: 100%;
    padding: 18px 0px;
    text-align: center;
    list-style: none;
    li {
      padding: 15px 0;
      text-transform: uppercase;
      font-family: SourceHanSerifCN-Regular;
      transform: matrix(1, 0, 0, 1, -600, 0);
      transition: all 1s;
      a {
        color: white;
        transition: all 1s;
        font-size: 16px;
      }
    }
  }
  @keyframes transition1 {
    0% {
      transform: translate(-100px, -100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px, -100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
      clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%);
    }
    100% {
      clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
    }
  }
  @media screen and (max-width: 1870px) {
    .mm {
      .main {
        width: 90%;
        margin-left: 5%;
        .right {
          margin-left: 2%;
          width: 70%;
          ul {
            li {
              margin-left: 1%;
            }
          }
        }
      }
    }
  }
  // @media screen and (max-width: 1680px){
  //     .mm{
  //         .main{
  //             width:90%;
  //             margin-left: 5%;
  //             .right{
  //                 margin-left: 2%;
  //                 width:70%;
  //                 ul{
  //                     li{
  //                         margin-left: 1%;
  //                     }
  //                 }
  //             }
  //         }
  //     }
  // }
  @media screen and (max-width: 1366px) {
    .mm {
      .main {
        width: 90%;
        margin-left: 5%;
        .right {
          margin-left: 2%;
          width: 70%;
          ul {
            li {
              margin-left: 1%;
              a {
                padding: 0;
              }
            }
          }
        }
        .phone {
          div {
            margin-right: 5px;
          }
          .dh {
            margin-left: 10px;
            width: 130px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .mm {
      display: none;
    }
    .search {
      display: none;
    }
    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      transition: all 2s;
      background-color: black;
      a {
        text-align: center;
        display: inline-block;
        text-align: center;
        padding: 10px 0;
        width: 100%;
        img {
          margin-top: 10px;
        }
      }
    }
    .mNav {
      display: block;
      transition: 0.8s;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60px;
    }
    .mNav .burger {
      width: 32px;
      height: 3px;
      background-color: white;
      position: absolute;
      top: 20px;
      left: 50%;
      margin: 0px 0px 0px -16px;
      transform-origin: center;
      transition: 0.8s;
    }
    .mNav .burger:nth-of-type(2) {
      top: 30px;
    }
    .mNav .burger:nth-of-type(3) {
      top: 40px;
    }
    .mNav.active {
      /*background-color:#2bad38;*/
    }
    .mNav.active .burger {
      background-color: #ea5404;
    }
    .mNav.active .burger:nth-of-type(1) {
      top: 30px;
      transform: rotate(225deg);
    }
    .mNav.active .burger:nth-of-type(2) {
      left: -100%;
      opacity: 0;
    }
    .mNav.active .burger:nth-of-type(3) {
      top: 30px;
      transform: rotate(-225deg);
    }
  }
}
.dark {
  background-color: black;
  /*@media screen and (max-width:450px){*/
  /*    .mImg{*/
  /*        display: none;*/
  /*    }*/
  /*    .mImg2{*/
  /*        display: block;*/
  /*    }*/
  /*    .mNav .burger{*/
  /*        background-color: #0C3665;*/
  /*    }*/
  /*}*/
}
</style>
